export interface Movie {
  id: string;
  title: string;
  cover: string;
  type: string;
  genre: string;
  region: string;
  year: number;
  duration: string;
  director: string;
  actors: string[];
  summary: string;
  tags: string[];
  views: number;
  status: string;
  updatedAt: string;
  featured: boolean;
}

export const movieTypes = ['电影', '电视剧', '综艺', '动漫'] as const;

export const movieGenres = [
  '剧情', '科幻', '悬疑', '动作', '爱情', '喜剧', '古装', '犯罪', '奇幻', '家庭', '冒险', '纪实', '音乐', '美食', '治愈', '热血',
];

export const movieRegions = ['中国大陆', '中国香港', '中国台湾', '美国', '韩国', '日本', '英国', '法国'];

export const movieYears = [2025, 2024, 2023, 2022];

export const movies: Movie[] = [
  {
    id: '1',
    title: '都市迷航',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20figure%20walking%20through%20a%20rain%20soaked%20futuristic%20city%20at%20night%2C%20deep%20navy%20blue%20tones%20with%20warm%20orange%20neon%20reflections%2C%20moody%20atmospheric%20lighting%2C%20minimal%20clean%20composition%2C%20high%20detail%20editorial%20poster%20art&width=600&height=900&seq=mmv-cover-01&orientation=portrait',
    type: '电影',
    genre: '科幻',
    region: '中国大陆',
    year: 2024,
    duration: '118分钟',
    director: '陈望舒',
    actors: ['周砚', '林舒禾', '许南舟'],
    summary: '一场突如其来的城市断电，让整座都市陷入夜色。一名数据工程师循着微弱信号，在霓虹与雨幕之间寻找失踪的搭档，也重新拼凑起自己对这座城市的记忆。',
    tags: ['科幻', '都市', '悬疑', '中国大陆'],
    views: 286000,
    status: '已上线',
    updatedAt: '2025-09-28',
    featured: true,
  },
  {
    id: '2',
    title: '长夜将尽',
    cover: 'https://readdy.ai/api/search-image?query=Suspense%20film%20poster%20of%20a%20misty%20northern%20town%20at%20dawn%20with%20silhouetted%20houses%20and%20a%20single%20lit%20window%2C%20cold%20steel%20blue%20palette%20with%20a%20faint%20amber%20glow%2C%20cinematic%20tension%20and%20quiet%20mystery%2C%20minimal%20typographic%20space%2C%20high%20detail%20dramatic%20poster&width=600&height=900&seq=mmv-cover-02&orientation=portrait',
    type: '电影',
    genre: '悬疑',
    region: '中国大陆',
    year: 2025,
    duration: '126分钟',
    director: '苏行舟',
    actors: ['顾之野', '温晓棠', '陆铭'],
    summary: '小镇接连发生离奇失窃案，退休警探被请回调查。随着线索层层剥开，一桩被掩埋多年的旧事浮出水面，长夜将尽，人心难测。',
    tags: ['悬疑', '犯罪', '剧情', '中国大陆'],
    views: 342000,
    status: '已上线',
    updatedAt: '2025-10-02',
    featured: true,
  },
  {
    id: '3',
    title: '霓虹之城',
    cover: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20poster%20of%20downtown%20Hong%20Kong%20style%20streets%20at%20night%20with%20layered%20neon%20signs%20and%20wet%20asphalt%20reflections%2C%20deep%20indigo%20and%20orange%20contrast%2C%20sleek%20cinematic%20grade%2C%20urban%20noir%20atmosphere%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-03&orientation=portrait',
    type: '电影',
    genre: '犯罪',
    region: '中国香港',
    year: 2023,
    duration: '110分钟',
    director: '麦子谦',
    actors: ['郑兆康', '何婉仪', '雷振东'],
    summary: '一名卧底警员在霓虹闪烁的旧城区潜伏多年，当身份即将暴露，他必须在忠诚与生存之间做出抉择。',
    tags: ['犯罪', '动作', '都市', '中国香港'],
    views: 198000,
    status: '已上线',
    updatedAt: '2025-08-19',
    featured: false,
  },
  {
    id: '4',
    title: '山海拾遗',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20epic%20poster%20of%20ancient%20mountain%20peaks%20emerging%20above%20a%20sea%20of%20clouds%20with%20mythical%20glowing%20beasts%20in%20silhouette%2C%20ink%20wash%20texture%20blended%20with%20deep%20blue%20and%20golden%20amber%2C%20grand%20mystical%20mood%2C%20elegant%20minimal%20composition%2C%20high%20detail%20fantasy%20key%20art&width=600&height=900&seq=mmv-cover-04&orientation=portrait',
    type: '电视剧',
    genre: '奇幻',
    region: '中国大陆',
    year: 2025,
    duration: '全40集',
    director: '白青野',
    actors: ['沈砚清', '叶知秋', '江云澜'],
    summary: '少年意外获得一卷残缺的古图，为寻回散落人间的异兽，他走遍山海秘境，在山河志怪之间，书写一段关于守护与成长的旅程。',
    tags: ['奇幻', '古装', '冒险', '中国大陆'],
    views: 512000,
    status: '更新至第32集',
    updatedAt: '2025-10-10',
    featured: true,
  },
  {
    id: '5',
    title: '春江花月',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20costume%20drama%20poster%20of%20a%20moonlit%20river%20pavilion%20with%20hanging%20lanterns%20and%20blossoming%20branches%2C%20soft%20moonlight%20over%20ink%20blue%20water%20with%20warm%20amber%20lantern%20glow%2C%20poetic%20elegant%20atmosphere%2C%20refined%20traditional%20painting%20style%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-05&orientation=portrait',
    type: '电视剧',
    genre: '古装',
    region: '中国大陆',
    year: 2024,
    duration: '全36集',
    director: '柳承颜',
    actors: ['容晚舟', '顾清和', '宋含章'],
    summary: '江南水乡，两代匠人以织造为业。春江潮起，花月流转，一段跨越家国与岁月的匠人故事在水墨长卷中缓缓展开。',
    tags: ['古装', '爱情', '剧情', '中国大陆'],
    views: 423000,
    status: '已完结',
    updatedAt: '2025-09-15',
    featured: false,
  },
  {
    id: '6',
    title: '星光背面',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20of%20two%20figures%20standing%20apart%20on%20a%20rooftop%20under%20a%20vast%20starry%20night%20sky%2C%20soft%20midnight%20blue%20gradient%20with%20delicate%20warm%20highlight%2C%20tender%20melancholic%20mood%2C%20airy%20minimal%20composition%2C%20high%20detail%20cinematic%20key%20art&width=600&height=900&seq=mmv-cover-06&orientation=portrait',
    type: '电影',
    genre: '爱情',
    region: '韩国',
    year: 2024,
    duration: '104分钟',
    director: '金秀贤',
    actors: ['韩智恩', '朴叙'],
    summary: '舞台灯光下的他们是最好的搭档，聚光灯之外却各自怀揣心事。当星光熄灭，两人终于愿意面对真实的彼此。',
    tags: ['爱情', '音乐', '剧情', '韩国'],
    views: 176000,
    status: '已上线',
    updatedAt: '2025-08-30',
    featured: false,
  },
  {
    id: '7',
    title: '深海回声',
    cover: 'https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20poster%20of%20a%20submersible%20descending%20into%20a%20dark%20trench%20with%20bioluminescent%20lights%20and%20distant%20structures%2C%20deep%20ocean%20blue%20with%20cyan%20and%20orange%20accents%2C%20mysterious%20vast%20scale%2C%20clean%20cinematic%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-07&orientation=portrait',
    type: '电影',
    genre: '科幻',
    region: '美国',
    year: 2025,
    duration: '131分钟',
    director: 'M. Hale',
    actors: ['E. Carter', 'N. Brooks', 'L. Reyes'],
    summary: '一支深海科考队在海沟深处捕捉到规律的低频回声。为了查明来源，他们驶向人类从未抵达的海底，也驶向未知的边界。',
    tags: ['科幻', '冒险', '悬疑', '美国'],
    views: 389000,
    status: '已上线',
    updatedAt: '2025-09-22',
    featured: false,
  },
  {
    id: '8',
    title: '第七个黎明',
    cover: 'https://readdy.ai/api/search-image?query=British%20mystery%20series%20poster%20of%20a%20foggy%20coastal%20cliff%20village%20with%20a%20lighthouse%20beam%20cutting%20through%20grey%20mist%2C%20muted%20slate%20blue%20and%20warm%20lamp%20light%2C%20quiet%20dread%20cinematic%20atmosphere%2C%20restrained%20elegant%20composition%2C%20high%20detail%20poster&width=600&height=900&seq=mmv-cover-08&orientation=portrait',
    type: '电视剧',
    genre: '悬疑',
    region: '英国',
    year: 2024,
    duration: '全8集',
    director: 'A. Whitmore',
    actors: ['C. Doyle', 'R. Hale', 'S. Ford'],
    summary: '海边小镇每隔七年便会有一次无人能解释的停电。新任警长到来后，发现所有线索都指向同一个被遗忘的黎明。',
    tags: ['悬疑', '犯罪', '剧情', '英国'],
    views: 231000,
    status: '已完结',
    updatedAt: '2025-07-11',
    featured: false,
  },
  {
    id: '9',
    title: '街头交响曲',
    cover: 'https://readdy.ai/api/search-image?query=Music%20reality%20show%20poster%20of%20a%20street%20band%20performing%20under%20stage%20lights%20with%20silhouetted%20crowd%2C%20vibrant%20warm%20orange%20and%20deep%20blue%20contrast%2C%20energetic%20live%20concert%20mood%2C%20dynamic%20modern%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-09&orientation=portrait',
    type: '综艺',
    genre: '音乐',
    region: '中国大陆',
    year: 2025,
    duration: '全12期',
    director: '综艺制作组',
    actors: ['林声', '阿栗', '小满'],
    summary: '来自不同城市的街头音乐人齐聚一堂，用一把琴、一副嗓子，在城市的天台上唱出属于自己的声音。',
    tags: ['音乐', '纪实', '中国大陆'],
    views: 268000,
    status: '更新至第9期',
    updatedAt: '2025-10-08',
    featured: true,
  },
  {
    id: '10',
    title: '荒野征途',
    cover: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20poster%20of%20hikers%20crossing%20a%20vast%20windswept%20plateau%20under%20a%20dramatic%20sky%2C%20earthy%20deep%20blue%20and%20amber%20light%2C%20epic%20expansive%20landscape%20mood%2C%20minimal%20bold%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-10&orientation=portrait',
    type: '综艺',
    genre: '冒险',
    region: '中国大陆',
    year: 2024,
    duration: '全10期',
    director: '纪实团队',
    actors: ['队伍A', '队伍B'],
    summary: '六位嘉宾背起行囊，走进人迹罕至的高原与峡谷。没有剧本，只有真实的荒野、真实的协作与真实的坚持。',
    tags: ['冒险', '纪实', '中国大陆'],
    views: 154000,
    status: '已完结',
    updatedAt: '2025-06-20',
    featured: false,
  },
  {
    id: '11',
    title: '机械之心',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20mecha%20poster%20of%20a%20young%20pilot%20beside%20a%20towering%20robot%20against%20a%20sunset%20skyline%2C%20deep%20blue%20shadow%20with%20vivid%20orange%20sky%20glow%2C%20hopeful%20epic%20mood%2C%20clean%20cel%20shaded%20illustration%2C%20high%20detail%20key%20visual&width=600&height=900&seq=mmv-cover-11&orientation=portrait',
    type: '动漫',
    genre: '科幻',
    region: '日本',
    year: 2025,
    duration: '更新至第22话',
    director: '动画监督 佐藤',
    actors: ['声优阵容'],
    summary: '在被机械守护的城市里，少年驾驶着拥有自我意识的机体，去寻找传说中能让机器与人类共存的答案。',
    tags: ['科幻', '热血', '冒险', '日本'],
    views: 476000,
    status: '更新至第22话',
    updatedAt: '2025-10-12',
    featured: false,
  },
  {
    id: '12',
    title: '云上牧场',
    cover: 'https://readdy.ai/api/search-image?query=Healing%20anime%20poster%20of%20rolling%20green%20pastures%20above%20a%20sea%20of%20clouds%20with%20a%20tiny%20farmhouse%20and%20warm%20sunrise%2C%20soft%20sky%20blue%20and%20golden%20light%2C%20gentle%20peaceful%20atmosphere%2C%20clean%20hand%20painted%20illustration%2C%20high%20detail%20key%20visual&width=600&height=900&seq=mmv-cover-12&orientation=portrait',
    type: '动漫',
    genre: '治愈',
    region: '日本',
    year: 2024,
    duration: '全12话',
    director: '动画监督 高桥',
    actors: ['声优阵容'],
    summary: '少女来到云端的高原牧场，与一群性格各异的动物和村民朝夕相处。四季流转间，她慢慢找回了久违的平静。',
    tags: ['治愈', '家庭', '日本'],
    views: 187000,
    status: '已完结',
    updatedAt: '2025-05-18',
    featured: false,
  },
  {
    id: '13',
    title: '逆风而行',
    cover: 'https://readdy.ai/api/search-image?query=Inspiring%20drama%20poster%20of%20a%20cyclist%20climbing%20a%20steep%20mountain%20road%20in%20strong%20wind%2C%20dramatic%20deep%20blue%20storm%20sky%20with%20warm%20sunbreak%2C%20determined%20resilient%20mood%2C%20bold%20minimal%20composition%2C%20high%20detail%20cinematic%20poster&width=600&height=900&seq=mmv-cover-13&orientation=portrait',
    type: '电影',
    genre: '剧情',
    region: '中国大陆',
    year: 2023,
    duration: '112分钟',
    director: '孟长安',
    actors: ['秦牧', '丁晓'],
    summary: '一名因伤退役的自行车手重返赛场，在家乡的山路上重新学会与风、与疼痛、与自己和解。',
    tags: ['剧情', '热血', '家庭', '中国大陆'],
    views: 143000,
    status: '已上线',
    updatedAt: '2025-04-09',
    featured: false,
  },
  {
    id: '14',
    title: '沉默证人',
    cover: 'https://readdy.ai/api/search-image?query=Crime%20series%20poster%20of%20a%20rainy%20city%20street%20with%20a%20single%20distant%20figure%20under%20a%20streetlight%2C%20cold%20navy%20blue%20tones%20with%20amber%20light%2C%20tense%20noir%20atmosphere%2C%20restrained%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-14&orientation=portrait',
    type: '电视剧',
    genre: '犯罪',
    region: '美国',
    year: 2025,
    duration: '全10集',
    director: 'D. Nolan',
    actors: ['J. Parker', 'M. Vance'],
    summary: '唯一目击一桩案件的，是一台不愿说话的旧监控。两位警探循着沉默的影像，一步步逼近被掩盖的真相。',
    tags: ['犯罪', '悬疑', '剧情', '美国'],
    views: 297000,
    status: '已完结',
    updatedAt: '2025-09-03',
    featured: false,
  },
  {
    id: '15',
    title: '时光邮差',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20poster%20of%20a%20vintage%20mailbox%20in%20a%20cobblestone%20alley%20with%20letters%20floating%20into%20a%20glowing%20sky%2C%20dusk%20blue%20purple%20blend%20with%20gentle%20amber%20sparkle%2C%20whimsical%20tender%20mood%2C%20dreamy%20minimal%20composition%2C%20high%20detail%20poster&width=600&height=900&seq=mmv-cover-15&orientation=portrait',
    type: '电影',
    genre: '奇幻',
    region: '法国',
    year: 2024,
    duration: '99分钟',
    director: 'L. Moreau',
    actors: ['C. Laurent', 'A. Petit'],
    summary: '老城区的邮差发现，自己投递的信件总会送到过去的某一天。一封未寄出的信，让他决定改变一段早已注定的遗憾。',
    tags: ['奇幻', '爱情', '剧情', '法国'],
    views: 165000,
    status: '已上线',
    updatedAt: '2025-07-25',
    featured: false,
  },
  {
    id: '16',
    title: '城市褶皱',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20ensemble%20drama%20poster%20of%20overlapping%20apartment%20windows%20lit%20at%20dusk%2C%20deep%20indigo%20city%20silhouette%20with%20warm%20orange%20window%20glow%2C%20intimate%20human%20stories%20mood%2C%20layered%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-16&orientation=portrait',
    type: '电视剧',
    genre: '剧情',
    region: '中国大陆',
    year: 2025,
    duration: '全32集',
    director: '方嘉树',
    actors: ['许知遥', '贺兰', '曾一鸣'],
    summary: '同一栋老楼里，住着不同职业、不同年纪的人们。城市的褶皱之间，藏着许多看似平凡却彼此相连的生活。',
    tags: ['剧情', '家庭', '中国大陆'],
    views: 254000,
    status: '更新至第26集',
    updatedAt: '2025-10-06',
    featured: false,
  },
  {
    id: '17',
    title: '追风少年',
    cover: 'https://readdy.ai/api/search-image?query=Sports%20anime%20poster%20of%20a%20teenage%20athlete%20sprinting%20with%20motion%20streaks%20against%20a%20bright%20sky%2C%20energetic%20deep%20blue%20and%20vivid%20orange%20contrast%2C%20youthful%20passionate%20mood%2C%20dynamic%20clean%20cel%20illustration%2C%20high%20detail%20key%20visual&width=600&height=900&seq=mmv-cover-17&orientation=portrait',
    type: '动漫',
    genre: '热血',
    region: '中国大陆',
    year: 2024,
    duration: '全24话',
    director: '动画监督 顾',
    actors: ['声优阵容'],
    summary: '小镇少年为了一个看似荒唐的约定，加入了校田径队。风一样的少年，用一次次冲刺证明自己从未落后。',
    tags: ['热血', '青春', '中国大陆'],
    views: 209000,
    status: '已完结',
    updatedAt: '2025-06-02',
    featured: false,
  },
  {
    id: '18',
    title: '午夜厨房',
    cover: 'https://readdy.ai/api/search-image?query=Late%20night%20food%20show%20poster%20of%20a%20cozy%20street%20food%20stall%20glowing%20warmly%20in%20the%20dark%2C%20deep%20blue%20night%20with%20rich%20orange%20lantern%20light%2C%20warm%20welcoming%20atmosphere%2C%20appetizing%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-18&orientation=portrait',
    type: '综艺',
    genre: '美食',
    region: '中国大陆',
    year: 2025,
    duration: '全12期',
    director: '美食团队',
    actors: ['主厨阵容'],
    summary: '凌晨的街头厨房，只为一碗热汤留一盏灯。每位深夜来客都带着故事，每道菜都藏着一座城市的温度。',
    tags: ['美食', '纪实', '治愈', '中国大陆'],
    views: 221000,
    status: '更新至第10期',
    updatedAt: '2025-10-09',
    featured: false,
  },
  {
    id: '19',
    title: '玻璃森林',
    cover: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20poster%20of%20a%20modern%20glass%20office%20tower%20reflecting%20a%20distorted%20grey%20sky%2C%20cold%20steel%20blue%20palette%20with%20a%20sharp%20amber%20edge%20light%2C%20clinical%20unease%20atmosphere%2C%20geometric%20minimal%20composition%2C%20high%20detail%20poster&width=600&height=900&seq=mmv-cover-19&orientation=portrait',
    type: '电影',
    genre: '悬疑',
    region: '韩国',
    year: 2023,
    duration: '115分钟',
    director: '朴东贤',
    actors: ['柳敏书', '姜太河'],
    summary: '一位建筑设计师发现，自己亲手设计的玻璃大楼里，每个人的行踪都被精确记录。她决定走进自己建造的森林，找出真相。',
    tags: ['悬疑', '剧情', '都市', '韩国'],
    views: 172000,
    status: '已上线',
    updatedAt: '2025-03-27',
    featured: false,
  },
  {
    id: '20',
    title: '北极光下',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20series%20poster%20of%20a%20snowy%20northern%20village%20under%20green%20and%20blue%20aurora%20sky%2C%20deep%20midnight%20blue%20with%20soft%20green%20and%20warm%20window%20glow%2C%20serene%20dreamy%20mood%2C%20minimal%20elegant%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-20&orientation=portrait',
    type: '电视剧',
    genre: '爱情',
    region: '英国',
    year: 2024,
    duration: '全6集',
    director: 'H. Berg',
    actors: ['E. Lindqvist', 'T. Shaw'],
    summary: '气象研究员驻守极北小镇，记录极光的变化。与当地向导从争执到并肩，在被雪覆盖的日子里，慢慢看清彼此。',
    tags: ['爱情', '剧情', '英国'],
    views: 158000,
    status: '已完结',
    updatedAt: '2025-05-30',
    featured: false,
  },
  {
    id: '21',
    title: '数据风暴',
    cover: 'https://readdy.ai/api/search-image?query=Cyber%20thriller%20poster%20of%20a%20server%20room%20corridor%20with%20streaming%20data%20light%20trails%2C%20deep%20navy%20blue%20with%20electric%20orange%20highlights%2C%20tense%20high-tech%20mood%2C%20sleek%20geometric%20composition%2C%20high%20detail%20cinematic%20poster&width=600&height=900&seq=mmv-cover-21&orientation=portrait',
    type: '电影',
    genre: '科幻',
    region: '美国',
    year: 2024,
    duration: '122分钟',
    director: 'R. Cole',
    actors: ['A. Mensah', 'K. Ito'],
    summary: '一名网络安全专家在全球网络瘫痪前收到一段神秘代码。随着数据风暴席卷而来，他必须在倒计时结束前找到源头。',
    tags: ['科幻', '动作', '犯罪', '美国'],
    views: 264000,
    status: '已上线',
    updatedAt: '2025-08-08',
    featured: false,
  },
  {
    id: '22',
    title: '归乡之路',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%20of%20a%20rural%20road%20leading%20to%20a%20small%20village%20at%20golden%20sunset%2C%20deep%20brown%20and%20amber%20tones%20with%20a%20touch%20of%20dusk%20blue%2C%20tender%20nostalgic%20mood%2C%20simple%20heartfelt%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-22&orientation=portrait',
    type: '电影',
    genre: '家庭',
    region: '中国大陆',
    year: 2025,
    duration: '108分钟',
    director: '何知远',
    actors: ['郑守拙', '苏婉', '林望'],
    summary: '多年未归的游子因一封家书回到故乡。老屋、旧井、熟悉的乡音，让他在沉默中读懂了父母未曾说出口的牵挂。',
    tags: ['家庭', '剧情', '中国大陆'],
    views: 193000,
    status: '已上线',
    updatedAt: '2025-09-30',
    featured: false,
  },
  {
    id: '23',
    title: '笑对人生',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20variety%20show%20poster%20of%20a%20colorful%20stage%20with%20microphones%20and%20soft%20spotlights%2C%20warm%20orange%20and%20friendly%20blue%20gradient%2C%20playful%20upbeat%20mood%2C%20clean%20modern%20graphic%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=mmv-cover-23&orientation=portrait',
    type: '综艺',
    genre: '喜剧',
    region: '中国大陆',
    year: 2024,
    duration: '全15期',
    director: '喜剧团队',
    actors: ['喜剧阵容'],
    summary: '一群爱讲段子的普通人站上舞台，用最生活化的笑料讲述最真实的日子。笑一笑，日子就没那么难了。',
    tags: ['喜剧', '综艺', '中国大陆'],
    views: 149000,
    status: '已完结',
    updatedAt: '2025-04-22',
    featured: false,
  },
  {
    id: '24',
    title: '幻境守护者',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20poster%20of%20a%20young%20guardian%20holding%20a%20glowing%20crystal%20before%20floating%20islands%2C%20deep%20twilight%20blue%20with%20radiant%20orange%20and%20teal%20magic%20light%2C%20adventurous%20wondrous%20mood%2C%20detailed%20illustrated%20key%20visual%2C%20high%20detail%20composition&width=600&height=900&seq=mmv-cover-24&orientation=portrait',
    type: '动漫',
    genre: '奇幻',
    region: '日本',
    year: 2023,
    duration: '全26话',
    director: '动画监督 森',
    actors: ['声优阵容'],
    summary: '当现实与幻境的边界开始崩塌，年轻的守护者肩负起修复世界的使命。她要在流逝的记忆中，找回守护彼此的初心。',
    tags: ['奇幻', '冒险', '热血', '日本'],
    views: 312000,
    status: '已完结',
    updatedAt: '2025-02-14',
    featured: false,
  },
];

export const movieDisclaimer = '本站影视与海报均为演示数据，仅供界面展示使用。';